<p>blank-redirect works!</p>
